// Troca de senha obrigatoria (ex.: apos reset feito por admin).
// O backend responde 403 com detail === 'PASSWORD_CHANGE_REQUIRED' em toda rota
// protegida, exceto /auth/change-password, /auth/me e /auth/logout.
export const PASSWORD_CHANGE_REQUIRED = 'PASSWORD_CHANGE_REQUIRED';
export const CHANGE_PASSWORD_PATH = '/change-password';
export const PASSWORD_MIN_LENGTH = 8;

export const isPasswordChangeRequiredError = (error) => (
  error?.response?.status === 403
  && error?.response?.data?.detail === PASSWORD_CHANGE_REQUIRED
);

// Espelha a politica minima do backend (>= 8, ao menos uma letra e um digito).
// O backend continua sendo a fonte da verdade (inclui o historico de senhas).
export const PASSWORD_MAX_BYTES = 72; // limite efetivo do bcrypt

const utf8Length = (str) => unescape(encodeURIComponent(str)).length;

export const passwordPolicyError = (password) => {
  if (!password || password.length < PASSWORD_MIN_LENGTH) {
    return `A senha deve ter no mínimo ${PASSWORD_MIN_LENGTH} caracteres`;
  }
  if (utf8Length(password) > PASSWORD_MAX_BYTES) {
    return 'A senha é longa demais';
  }
  if (!/[A-Za-z]/.test(password) || !/\d/.test(password)) {
    return 'A senha deve conter ao menos uma letra e um número';
  }
  return null;
};

// 401 de uma requisicao autenticada (token revogado por troca/reset de senha,
// expirado...) — exceto o proprio login, cujo 401 e "credenciais invalidas".
export const isSessionRevokedError = (error) => {
  if (error?.response?.status !== 401) return false;
  const url = error?.config?.url || '';
  return !url.includes('/auth/login');
};

// Decide para onde o guard manda o usuario. null = pode seguir.
export const passwordChangeRedirect = (user, pathname) => {
  if (user?.must_change_password && pathname !== CHANGE_PASSWORD_PATH) {
    return CHANGE_PASSWORD_PATH;
  }
  return null;
};
